import React, { Component } from "react"

class NewsletterSignup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: this.props.title || "",
    }
  }

  getValue() {
    return {
      type: "newsletter-signup",
      props: this.state,
    }
  }

  validate() {
    if (!this.state.title) {
      return false
    }
    return true
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    return (
      <div style={{ margin: 10 }}>
        <div className="form-group">
          <label>Newsletter Signup Title/Description</label>
          <div className="form-group">
            <input
              onChange={(e) => this.handleInputChange(e)}
              value={this.state.title}
              name="title"
              placeholder="eg: A weekly burst of proprietary data and flash insights spanning the space as a sanity-check, juxtaposed to the hype and sentiment throughout the space"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default NewsletterSignup
